import * as React from 'react'

import { Colors } from '../../../constants/colors'
import { BaseIconProps } from '../types'

function TeamIcon({ size = 24, color = Colors.N100, title }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <title>{title}</title>
      <path
        d="M13.5 14a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13.5 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM19.5 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM4.5 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z"
        stroke={color}
      />
      <path clipRule="evenodd" d="M8 20.5h8V19s-2-2-4-2-4 2-4 2v1.5z" stroke={color} strokeLinejoin="round" />
      <path
        d="M15.033 9.15C14.022 8.383 13.01 8 12 8c-.98 0-1.958.36-2.938 1.078M18 17.5h4V16c-1.333-1.333-2.667-2-4-2-.827 0-1.654.256-2.48.77M6 17.5H2V16c1.333-1.333 2.667-2 4-2 .827 0 1.654.256 2.48.77"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TeamIcon
